export default {
  'get-list': {
    method: 'post',
    url: '/client/vehicle/insurance/list'
  },
  add: {
    method: 'post',
    url: '/client/vehicle/insurance'
  },
  update: {
    method: 'put',
    url: '/client/vehicle/insurance/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/vehicle/insurance'
  }
}
